import { useState, useEffect } from "react";
import queryString from "query-string";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import api from "../../services/api";
import { setUser, setApp } from "../../redux/auth/actions";

export default ({}) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { token, user_id, redirect_url } = queryString.parse(location.search);

  async function init() {
    try {
      api.setToken(token);
      const res = await api.get(`/user/token_user_login_as/${user_id}`);
      console.log("res", res);
      if (!res.ok) return setLoading(false);
      api.setToken(res.token);

      dispatch(setUser(res.user));
      dispatch(setApp(res.user.application));

      console.log("App", res.user);

      setLoading(false);
      navigate(redirect_url || "/");
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  }

  useEffect(() => {
    init();
  }, []);

  if (loading === null) return <div>Erreur</div>;
  if (!loading) return <div>Loading ...</div>;

  return <div>Loading ...</div>;
};
